import Noop from "@marginly/ui/components/helpers/noop";
import T from "@marginly/ui/components/typography";
import React from "react";
import { useAccount } from "wagmi";

import { getFarmTokenSymbol } from "@/app/util";
import { TokenImage } from "@/components/common/token";
import { useTokenBalance } from "@/hooks/wagmi/use-token-balance";
import { formatCoin } from "@/util/format-coin";

import * as S from "./styled";
interface Props {
  onClick: () => void;
  isSelected: boolean;
  tokenAddress: `0x${string}` | undefined;
  symbol: string;
}

export function AssetItem({
  onClick,
  isSelected,
  tokenAddress,
  symbol,
}: Props) {
  const account = useAccount();
  const balance = useTokenBalance({
    address: account?.address,
    token: tokenAddress,
  });
  const amount = formatCoin(balance.data?.formatted);
  return (
    <S.Wrapper onClick={onClick}>
      <TokenImage token={symbol} rectangle />
      <T body>
        {amount} {getFarmTokenSymbol(symbol)}
      </T>
      {isSelected ? (
        <img
          src="/images/check.svg"
          alt=""
          style={{
            filter: "invert(var(--svg-invert))",
          }}
          className="arrow-right"
        />
      ) : (
        <Noop />
      )}
    </S.Wrapper>
  );
}
